import { create } from "zustand"
import { devtools } from "zustand/middleware"

export interface WorksState {
  isSectionReady: boolean
  setIsSectionReady: (isSectionReady: boolean) => void
}

export const useWorksStore = create<WorksState>()(
  devtools((set) => ({
    isSectionReady: false,
    setIsSectionReady: (isSectionReady: boolean) => set({ isSectionReady }),
  })),
)
